import { INote } from './notes.interface';

let allNotes: INote[] = [];

const notesCountSelector = document.getElementById('notesCountSelector') as HTMLSelectElement;
const searchNotesInput = document.getElementById('searchNotes') as HTMLInputElement;
const notesContainer = document.getElementById('notesContainer') as HTMLDivElement;
const notesList = document.getElementById('notesList') as HTMLDivElement;
const notesCountNumber = document.getElementById('notesCountNumber') as HTMLElement;

function highlightText(text: string, term: string): string {
    if (!term) return text;
    const escaped = term.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    return text.replace(new RegExp(escaped, 'gi'), match => `<span class="highlight">${match}</span>`);
}

function getFavicon(url: string): string {
    try {
        const domain = new URL(url).origin;
        return `${domain}/favicon.ico`;
    } catch {
        return '';
    }
}

function formatDate(timestamp: number): string {
    const d = new Date(timestamp * 1000);
    return d.toLocaleString(undefined, {
        year: 'numeric',
        month: 'short',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        hour12: false
    });
}

function createNoteCard(note: INote, term: string): HTMLDivElement {
    const card = document.createElement('div');
    card.className = 'card';

    const header = document.createElement('div');
    header.className = 'card-header';

    const textDiv = document.createElement('div');
    textDiv.className = 'text';
    textDiv.innerHTML = note.text ? highlightText(note.text, term) : '';
    header.appendChild(textDiv);

    const ts = document.createElement('div');
    ts.className = 'timestamp';
    ts.textContent = `${formatDate(note.created_at)}`;
    header.appendChild(ts);

    // Check if both text and at least one url exist
    const hasText = !!note.text;
    const hasUrls = Array.isArray(note.urls) && note.urls.length > 0;
    if (hasText && hasUrls) {
        header.classList.add('card-header--with-footer');
    }

    card.appendChild(header);

    // Track the first urlObj with OG data
    let firstOgUrlObj: any = null;

    (note.urls || []).forEach((urlObj) => {
        const urlDiv = document.createElement('div');
        urlDiv.className = 'url';

        const favicon = document.createElement('img');
        favicon.src = getFavicon(urlObj.url);
        favicon.className = 'favicon';
        favicon.onerror = () => favicon.style.display = 'none';

        const link = document.createElement('a');
        link.className = 'url';
        link.href = urlObj.url;
        link.innerHTML = urlObj.url ? highlightText(urlObj.url, term) : '';
        link.target = '_blank';

        urlDiv.appendChild(favicon);
        urlDiv.appendChild(link);
        card.appendChild(urlDiv);

        // Save the first urlObj with OG data
        if (!firstOgUrlObj && urlObj.og_title) {
            firstOgUrlObj = urlObj;
        }
    });

    // Render OG preview after the loop, if found
    if (firstOgUrlObj) {
        const preview = document.createElement('div');
        preview.className = 'og-preview';

        if (firstOgUrlObj.og_image) {
            const ogImg = document.createElement('img');
            ogImg.className = 'og-image';
            ogImg.src = firstOgUrlObj.og_image;
            ogImg.onerror = () => ogImg.style.display = 'none';
            preview.appendChild(ogImg);
        }

        const meta = document.createElement('div');
        meta.className = 'og-text';
        const title = document.createElement('div');
        title.className = 'og-title';
        title.innerHTML = firstOgUrlObj.og_title ? `<strong>${highlightText(`${firstOgUrlObj.og_title}`, term)}</strong>` : '';
        meta.appendChild(title);

        if (firstOgUrlObj.og_description) {
            const desc = document.createElement('div');
            desc.className = 'og-description';
            desc.innerHTML = firstOgUrlObj.og_description ? highlightText(firstOgUrlObj.og_description, term) : '';
            meta.appendChild(desc);
        }

        const ogLink = document.createElement('a');
        ogLink.href = firstOgUrlObj.url;
        ogLink.target = '_blank';
        ogLink.appendChild(meta);
        preview.appendChild(ogLink);
        card.appendChild(preview);
    }

    return card;
}

function renderNotes(notes: INote[] = allNotes) {

    destroyNoteListScrollbar();

    const limit = notesCountSelector.value === 'all' ? allNotes.length : parseInt(notesCountSelector.value, 10);
    const term = searchNotesInput.value.trim().toLowerCase();
    const filtered = allNotes.filter(note =>
        (note.text && note.text.toLowerCase().includes(term)) ||
        (note.urls && note.urls.some(urlObj =>
            (urlObj.url && urlObj.url.toLowerCase().includes(term)) ||
            (urlObj.og_title && urlObj.og_title.toLowerCase().includes(term)) ||
            (urlObj.og_description && urlObj.og_description.toLowerCase().includes(term))
        ))
    );

    //notesCountNumber.textContent = `${filtered.length}`;

    const toRender = filtered.slice(0, limit);
    notesList.innerHTML = '';

    for (const note of toRender) {
        const card = createNoteCard(note, term);
        notesList.appendChild(card);
    }

    setupNoteListScrollbar();
}

async function fetchNotes() {
    try {
        notesList.innerHTML = "<p>Loading...</p>"; // Temporary loading text

        const baseUrl = window.location.hostname === "localhost"
            ? "https://davidg.cc/"
            : "";

        // chmod 644 to allow public access
        const res = await fetch(`${baseUrl}notes.php`);

        const data = await res.json();
        allNotes = data;
        notesCountNumber.textContent = `${allNotes.length}`;
        renderNotes();
    } catch (error) {
        console.error("Error fetching notes:", error);
        notesList.innerHTML = "<p>Error loading notes.</p>";
    }
}

function configure() {
    if (!notesCountSelector || !searchNotesInput || !notesContainer || !notesList || !notesCountNumber) {
        console.error("Required elements not found in the DOM.");
        return;
    }
    notesCountSelector.addEventListener('change', () => { renderNotes(); });
    searchNotesInput.addEventListener("input", () => {
      const query = (searchNotesInput as any).value.toLowerCase();
      const filtered = allNotes.filter(note => (note.text || "").toLowerCase().includes(query));
      renderNotes(filtered);
    });
    searchNotesInput.addEventListener('input', () => { renderNotes(); });
}

function destroyNoteListScrollbar() {
	if ($("#notesContainer").hasClass("mCustomScrollbar")) {
		$("#notesContainer").mCustomScrollbar("destroy");
	}
}

function setupNoteListScrollbar() {
	$("#notesContainer").mCustomScrollbar({
		theme: "minimal-dark",
		axis: "y",
		autoDraggerLength: true
	});
}

export function loadNotes() {
    configure();
    fetchNotes();
}
